import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ApiService } from "../../../service/ApiService";

import { validateEmail } from "../../../utils/helpers";

import { Button } from "../../ui/Button/Button";
import { Input } from "../../ui/Input/Input";
import { addStyles } from "./addStyles";

import { Section } from "../Section/Section.styled";
import { Container } from "../Сontainer/Container.styled";
import { Form, Text, Title, Wrapper, WrapperRoot } from "./Subscribe.styled";

export const Subscribe = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState("");

  const handleSubmit = async event => {
    event.preventDefault();
    const validationError = validateEmail(email, t);
    if (!validationError) {
      try {
        setIsLoading(true);
        await ApiService.postSubscribe({ email });
        setEmail("");
        toast.success(t("global.thanks"));
      } catch (e) {
        toast.error(e?.response?.data?.userMessage ?? t("global.error"));
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Section variant="subscribe">
      <Container>
        <WrapperRoot>
          <Wrapper>
            <Title>{t("subscribe.title")}</Title>

            <Text>{t("subscribe.description")}</Text>
          </Wrapper>

          <Form noValidate onSubmit={handleSubmit}>
            <Input
              addStyles={addStyles.input}
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />

            <Button
              type="submit"
              styles={addStyles.button}
              isLoading={isLoading}
            >
              {t("subscribe.button")}
            </Button>
          </Form>
        </WrapperRoot>
      </Container>
    </Section>
  );
};
